
export const STATUS_LIST = [
    {
        key: 1,
        name: '启用'
    },
    {
        key: 0,
        name: '停用'
    }, {
        key: 2,
        name: '未启用'
    }
]
